export const jobsDesc = [
  {
    jobtitle: "Database Developer",
    link: "/database-developer",
    metaTitle:"Database Developer: 5+ Years - Job Description | Idexcel",
    jobdesc: [
      "Minimum 3+ Years of hands-on exposure in Rest Assured.",
      "Develop Test Framework for API's and Front end/Backend testing.",
      "Conducting and solving complex integration test cases.",
      "Expertise in API testing automation with strong programming skills.",
      "Proficiency in OOPS concept (Java).",
      "Experience in CI/CD and AWS Deployment.",
      "Maven, TestNG, POM, Cucumber, RESTQL.",
      "RPA Tool, Agile, JIRA, GIT, Deployment Pipeline, AWS.",
      "Design, develop and execute automation script using open source.",
      "Track quality assurance metrics.",
    ],
  },
  {
    jobtitle: "Data Scientist",
    link: "/data-scientist",
    metaTitle:"Data Scientist: 3 to 8 Years - Job Description | Idexcel",
    jobdesc: [
      " Must-Have: ML, Deep learning, NLP, (AWS or Azure or Google cloud), Python, Computer Vision.",
      "  Minimum of 4+ years of relevant experience in implementing and deploying Machine Learning solutions (using various models, such as Linear/Logistic Regression, Support Vector Machines, (Deep) Neural Networks, Hidden Markov Models, Conditional Random Fields, Topic Modeling, Game Theory, Mechanism Design, etc.) ",
      "  Knowledge of LLM Models.",
      " Extensive experience in handling Time-series data.",
      " Experience in working on anomaly detection.",
      " Experience in handling structured and unstructured data.",
      " Strong hands-on experience with statistical packages and ML libraries (e.g., Python scikit learn, Spark MLlib, etc.)",
      " Experience in developing and debugging in one or more of the languages Python.",
    ],
  },
  {
    jobtitle: "AWS Cloud Engineer",
    link: "/aws-cloud-engineer",
    metaTitle:"AWS Cloud Engineer: 4 to 10 Years- Job Description | Idexcel",
    jobdesc: [
      "Hands-on Experience on implementing solutions on AWS following well-architected framework.",
      "Hands-on Experience in Compute, Storage, Management, Governance, Security & Compliance services (EC2/ECS, S3, IAM, Lambda, Api Gateway, SNS, SQS, Kinesis, CloudWatch, CloudFront, Code Pipeline, Code Build, Code Deploy, Config, Guard Duty, Security Hub, AWS Developer Tools etc.)",
      "Hands-on experience in CloudFormation templates/IaC.",
      "Experience / Understanding of DevOps process and tools (AWS, Jenkins, Ansible etc.)",
      "Knowledge in AWS Accounts administration / Management - AWS Organizations, SCPs, Consolidated Billing",
      "Knowledge of information security standards & requirements (ISO, SOC2 etc.)",
      "Development background - Python/Nodejs/.net/java",
      "Good to Have: Knowledge of shell scripting.",
    ],
  },
  {
    jobtitle: "Full Stack Developer",
    link: "/full-stack-developer",
    metaTitle:"Full Stack Developer - Job Description | Idexcel",
    jobdesc: [
      "Expertise in Javascript, , NodeJS, React.JS, Angular JS and Jest",
      "5+ years of experience in front-end and Backend web development using JS framework (React.JS, Node.js, Angular)",
      "2 to 3 years of experience with a JS unit testing library (Jest, Mocha)",
      "2 to 3 years of experience in database technology preferably RDBMS/ ORDBMS",
      "2+ years of experience with Github and advanced Github features",
      "Experience working with large microservice-based architectures",
    ],
  },
  {
    jobtitle: "NodeJS Developer",
    link: "/nodejs-developer",
    metaTitle:"NodeJS Developer - Job Description | Idexcel",
    jobdesc: [
      " Overall 7+ years of work experience in software development.",
      "5+yrs of work experience relevant in NodesJS is mandatory.",
      "Must be strong in coding.",
      "Experience on building services using Rest API is Mandatory.",
      "Experience in leading / mentoring a technical team comprising of people not less than 2.",
      "Experience with relational and non-relational (e.g. MySQL, Mongo DB / Dynamo Db etc.)",
      "Experience with any of the following: code refactoring, design patterns, design driven development, continuous integration, building highly scalable applications, application security.",
      "Knowledge on cloud infrastructure, especially AWS cloud and container technologies like Docker is a plus",
      "Building mobile, responsive/adaptive applications (e.g., Native Mobile Application / React Native) is a plus",
    ],
  },
  {
    jobtitle: "Java Micro-Service Developers (5-7 years of experience)",
    link: "/java-micro-service-developers",
    metaTitle:"Java Micro-Service Developers (5-7 years of experience) - Job Description | Idexcel",
    jobdesc: [
      " Senior Developer with strong analytical and technical ability with over 5 years of experience in enterprise Web applications, REST services and Workflow Processing Service development using Java/J2EE technologies.",
      "Should have strong knowledge and hands on experience in JAVA (Version 1.8 or above) / J2EE / Spring boot / restful Web Services",
      "Expertise in Server less, tomcat (Embedded/Non-Embedded), jetty (Embedded/Non-Embedded), WebSphere",
      "Should have strong insight on OOPS concept and good hands on experience on JAVA (Version 1.8 or above) / J2EE / Spring boot / restful Web Services, Spring IOC, Spring Annotation, Spring Security.",
      "Expertise in mocking, Junit and perf testing of solutions.",
      "Should possess basic Unix/Linux knowledge to be able to write and understand basic shell scripts and basic Unix commands",
      "Knowledge of Oracle (PL/SQL), NoSQL-Mongo, Rules Engine,",
      "Candidates with working knowledge on Docker / Kubernetes / OpenShift / Mesos is a plus.",
      "Have basic experience in Data Preparation Tools Experience with CI/CD build pipelines and toolchain – Git, BitBucket, TeamCity, Artifactory, Jira Experience.",
      "Knowledge of testing concepts (TDD) is a plus.",
      "Strong design skills on Java/J2EE based solutions with Postgres/Mongo backend",
      "Person should have worked in Agile/DevOps Environment.",
    ],
  },
  {
    jobtitle: "Data Engineer",
    link: "/data-engineer",
    metaTitle:"Data Engineer - Job Description | Idexcel",
    jobdesc: [
      " Masters or PhD in Computer Science, Physics, Engineering or Math.",
      "Experience in data mining, large scale data acquisition, transformation, and cleaning.",
      "Hands on experience working on large-scale data science/data analytics projects.",
      "Ability to lead effectively across organizations.",
      "Hands-on experience with Data Analytics technologies such as AWS, ,Spark, Spark SQL, Python",
      "Implementing AWS services in a variety of distributed computing, enterprise environments.",
      "Proficiency with at least one the languages such as Python/Node.JS or Java.",
      "Experience defining system architectures and exploring technical feasibility trade-offs.",
      "3+ years experiences developing cloud software services and an understanding of design for scalability, performance and reliability.",
      "Experience working on a code base with many contributors.",
      "Ability to prototype and evaluate applications and interaction methodologies.",
      "Experience with AWS technology stack.",
    ],
  },
  {
    jobtitle: "Principal AWS Data Solutions Architect",
    link: "/principal-aws-data-solutions-architect",
    metaTitle:"Principal AWS Data Solutions Architect - Job Description | Idexcel",
    jobdesc: [
      "Must have proven history of successfully managing and delivery of complex analytics projects and big data solutions on AWS",
      "Extensive experience in Architecting, designing, and implementing the data flow from on premise application into an AWS Data Lake",
      "Expert in establishing implementation strategies for enterprise data warehouse with primary focus on Business intelligence, Analytics and Data governance.",
      "Expertise in analysis, design, and development of ETL programs and assist in trouble shooting for complex business programs",
      "Hands on expertise in Data ingestion, integration and ETL architecture",
      "Experience in architecting, deploying, and managing cost effective and secure AWS environment across multi-zones and regions",
      "Hands on experience in advanced Data model/Data mart design",
      "Design New Solutions - collaborate with data and engineering architects and development teams to design and build cutting edge AWS data ingestion, enrichment, and accessibility capabilities",
      "AWS Thought Leadership ¬ partner with solution architects and software development engineering teams to provide thought leadership on AWS data capabilities",
      "Cost Effective Engineering – engage with key business stakeholders and technical staff to appropriately understand and recommend solutions that balance AWS costs against the resulting technical benefits.",
      "Advise - Advisory role to executive engineering, data, and product leadership and ability to influence key digital strategies",
      "Hands-on Participation - Hands on participation in the full life cycle of definition, design, implementation, testing, and support.",
    ],
  },
  {
    jobtitle: "Loan SME Business Analyst",
    link: "/loan-sme-business-analyst",
    metaTitle:"Loan SME Business Analyst - Job Description | Idexcel",
    jobdesc: [
      "Well experience in Loan Process (All Loan types - Working capital, Bill Discounting, Term loan, credit line loan, Moorgate loan etc.)",
      "Having experience of 7-10 years.",
      "Having experienced on giving solution from scratch to Loan product.",
      "Well aware of Business Analyst process & documentation.",
      "Preferable as Certified BA",
      "Having experience on US banking system/Products is preferable",
    ],
  },
];
